import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Data2Service } from '../../common/data2.service';
import { InfoboxService } from '../../common/infobox/infobox.service';

@Component({
	selector: 'app-tourism-timetable',
	templateUrl: './tourism-timetable.component.html',
	styleUrls: ['./tourism-timetable.component.css'],
})
export class TourismTimetableComponent implements OnInit {
	loader = true;
	saveStatus = 'saved';
	private itemsBeforeDataLoad = 2;
	private cities: Array<any> = [];
	private citiesConnections: Array<any> = [];
	side = '';
	vehiclesAll: Array<any> = [];
	vehicles: Array<any> = [];
	seasons: Array<any> = [];
	data: Array<any> = [];
	sideName = '';
	arrivalDate = '2021-06-15';
	departureDate = '2021-06-15';
	departureFromDestination = '2021-06-15';
	eventDate = '2021-06-15';
	daysToDestination = 999;
	id: number = this.route.snapshot.params.id;
	showVehicles = false;
	isTour: Array<any> = [];
	email = '';
	web: Array<any> = [];
	private readonly multipliers = {
		osobowy: [1.1, 1.25, 1.35],
		bus: [1.1, 1.25, 1.35],
		autokar: [1.25, 1.32, 1.5],
	};

	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
		private readonly route: ActivatedRoute,
		private readonly router: Router,
	) {}

	ngOnInit(): void {
		this.api.get('/tourismTimetable/' + this.id, (result, error) => {
			const seasons = [];
			this.side = result.data.side;
			this.seasons = result.data.seasons;
			this.sideName = result.data.side == 'departure' ? 'Wyjazd' : 'Powrót';
			result.data.seasons.forEach((obj) => {
				seasons.push(obj.season);
				obj.days = parseInt(obj.days);
				if (this.daysToDestination > obj.days) {
					this.daysToDestination = obj.days;
					this.arrivalDate = obj.arrivalDate;
					this.departureDate = obj.departureDate;
					this.departureFromDestination = obj.departureFromDestination;
				}
				/*
				if (!this.daysToDestination) {
					this.daysToDestination = parseInt(obj.days);
					this.arrivalDate = obj.arrivalDate;
					this.departureDate = obj.departureDate;
					return;
				}
				if (this.daysToDestination != obj.days) {
					this.infobox.error('Daty zakwaterowań są różne');
					throw 'Daty zakwaterowań są różne';
				}
*/
			});
			const timetable = result.data;
			this.api.get('/vehicles/', (result, error) => {
				this.vehiclesAll = result.data;
				this.loadData(timetable);
			});
			this.api.get('/tourismStops/?ids=' + seasons.join(), (result, error) => {
				this.cities = result.data;
				this.loadData(timetable);
			});
		});
	}

	save() {
		this.saveStatus = 'saving';
		const data = [];
		this.data.forEach((item) => {
			const datetime = item.date && item.time ? item.date + ' ' + item.time : null;
			data.push({
				id: item.transportId,
				timetable: this.id,
				vehicle: item.vehicle.id,
				city: item.city.id,
				domestic: item.domestic,
				stopTime: item.stopTime,
				datetime: datetime,
				traffic: item.traffic,
			});
		});
		this.api.put('/tourismTimetableTransports/' + this.id, data, (result, error) => {
			this.saveStatus = 'saved';
		});
	}

	isTourGenerate() {
		this.email = '';
		this.isTour = [];
		this.data.forEach((data) => {
			if (this.isTour.some((obj) => obj.cityId == data.city.id)) {
				return;
			}
			if (!data.date || !data.time) {
				this.infobox.error(
					'Brak daty/godziny dla miasta: ' + data.city.name + ', dla pojazdu: ' + data.vehicle.name,
				);
				return;
			}
			this.isTour.push({
				cityId: data.city.id,
				cityCode: data.city.code,
				datetime: data.date + ' ' + data.time,
				date: data.date,
				time: data.time,
				timeBetween: 0,
			});
		});
		this.isTour.sort((a, b) => {
			return new Date(a.datetime).getTime() / 1000 - new Date(b.datetime).getTime() / 1000;
		});
		this.isTour.forEach((data, index) => {
			if (!this.isTour[index - 1] || !this.isTour[index - 1].date) {
				data.timeBetween = data.time;
				return;
			}
			const time1 = new Date(data.date + ' ' + data.time).getTime();
			const time2 = new Date(this.isTour[index - 1].date + ' ' + this.isTour[index - 1].time).getTime();
			const timeBetween = this.timeConvert((time1 - time2) / 1000);
			data.timeBetween = timeBetween;
		});
	}

	emailGenerate() {
		this.isTour = [];
		const link = 'https://erp.oskar.com.pl/tourism-timetable/' + this.id;
		this.email = "<p><a href='" + link + "'>" + link + '</a></p>';
		let data = [];
		switch (this.side) {
			case 'departure':
				data = this.data;
				break;
			case 'return':
				data = this.data.slice().reverse();
				break;
		}
		let first = true;
		data.forEach((obj, index) => {
			if (!obj.domestic) {
				return;
			}
			if (first || obj.vehicle.id != data[index - 1].vehicle.id) {
				this.email += '<br><b>' + obj.vehicle.name + '</b><br>';
			}
			this.email += obj.city.name + ', ';
			this.email += obj.city.detail + ', ';
			this.email += obj.date + ', ';
			this.email += ' godz. ' + obj.time.slice(0, 5);
			this.email += ' il.os.' + obj.people.get;
			this.email += '<br>';
			first = false;
		});
	}

	webGenerate() {
		this.web = [];
		this.seasons.forEach((season) => {
			let array: Array<any> = [];
			this.data.forEach((obj) => {
				if (!obj.domestic) {
					return;
				}
				array.push({
					product: season.destinationName,
					accomodationDate: season.accommodationFrom,
					date: obj.date,
					time: obj.time.slice(0, 5),
					cityName: obj.city.name,
					cityDetail: obj.city.detail,
				});
			});
			// Order by cityName
			array.sort((a, b) => a.cityName.localeCompare(b.cityName));
			// Remove duplicates
			array = array.filter((v, i, a) => a.findIndex((t) => t.cityName === v.cityName) === i);
			this.web.push(array);
		});
	}

	private timeConvert(seconds: number): string {
		if (seconds === 0) {
			return '00:00:00';
		}
		if (!seconds) {
			return '-1';
		}
		const d: number = Math.floor(seconds / (3600 * 24));
		const h: number = Math.floor((seconds % (3600 * 24)) / 3600) + d * 24;
		const m: number = Math.floor((seconds % 3600) / 60);
		const s: number = Math.floor(seconds % 60);
		const hDisplay: string = h < 10 ? '0' + h.toString() : h.toString();
		const mDisplay: string = m < 10 ? '0' + m.toString() : m.toString();
		const sDisplay: string = s < 10 ? '0' + s.toString() : s.toString();
		return hDisplay + ':' + mDisplay + ':' + sDisplay;
	}

	vehicleChanged() {
		this.showVehicles = false;
		this.loadVehicleChange();
		this.save();
	}

	hourChanged(item) {
		if (!item.date || !item.time) {
			return;
		}
		const transports = this.data.filter((transport) => transport.vehicle == item.vehicle && transport.domestic);
		this.setHoursForTransport(transports);
		// set time for other places started with the same city
		const otherTransports = this.data.filter(
			(transport) => transport.vehicle != item.vehicle && transport.timeEditable === true && transport.domestic,
		);
		otherTransports.forEach((transportFromFirstCity) => {
			const transportFromMainCity = transports.find((obj) => obj.city.id == transportFromFirstCity.city.id);
			if (!transportFromMainCity) {
				return;
			}
			transportFromFirstCity.date = transportFromMainCity.date;
			transportFromFirstCity.time = transportFromMainCity.time;
			const currentTransports = this.data.filter(
				(transport) => transport.vehicle == transportFromFirstCity.vehicle && transport.domestic,
			);
			this.setHoursForTransport(currentTransports);
		});
		this.save();
	}

	private setHoursForTransport(transports) {
		let minutes = 0;
		for (let index = transports.length; index >= 0; index--) {
			if (!transports[index + 1]) {
				continue;
			}
			if (!transports[index + 1].domestic) {
				continue;
			}
			minutes = this.findMinutesBetween(transports[index].city.id, transports[index + 1].city.id);
			minutes *= this.multipliers[transports[index].vehicle.type.id][transports[index].traffic];
			minutes = Math.floor(minutes);
			minutes += parseInt(transports[index + 1].stopTime);
			[transports[index].date, transports[index].time] = this.hourMinutesSubstract(
				transports[index + 1].date,
				transports[index + 1].time,
				minutes,
			);
		}
	}

	private hourMinutesSubstract(date: string, hour: string, minutes: number): Array<string> {
		const newDate = new Date(date + ' ' + hour);
		switch (this.side) {
			case 'departure':
				minutes = this.roundMinutes(newDate.getMinutes() - minutes);
				break;
			case 'return':
				minutes = this.roundMinutes(newDate.getMinutes() + minutes);
				break;
		}
		newDate.setMinutes(minutes);
		// toISOString olewa strefe czasowa, wiec trzeba robic dziwne rzeczy
		[date, hour] = new Date(newDate.getTime() - newDate.getTimezoneOffset() * 60000)
			.toISOString()
			.replace(/\..+/, '')
			.split('T');
		return [date, hour];
	}

	private roundMinutes(fullMinutes: number): number {
		let lastDigit: number = parseInt(fullMinutes.toString().slice(-1));
		const restDigits: string = fullMinutes.toString().slice(0, -1);
		if (lastDigit > 5) {
			lastDigit = 5;
		} else if (lastDigit > 0 && lastDigit < 5) {
			lastDigit = 0;
		}
		fullMinutes = parseInt(restDigits + lastDigit.toString());
		return fullMinutes;
	}

	private findMinutesBetween(city1: number, city2: number): number {
		const pos = this.citiesConnections.find(
			(pos) => (pos.from == city1 && pos.to == city2) || (pos.from == city2 && pos.to == city1),
		);
		return parseInt(pos.minutes);
	}

	private loadData(timetable) {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.data = [];
		this.vehicles = [];
		const citiesFromTo = [];
		timetable.transports.forEach((transport, index) => {
			transport.domestic = parseInt(transport.domestic);
			const vehicle = this.findVehicle(transport.vehicle);
			let vehicleType = 'fas fa-question';
			switch (vehicle.type.id) {
				case 'bus':
				case 'osobowy':
					vehicleType = 'fas fa-route';
					break;
				case 'autokar':
					vehicleType = 'fas fa-bus';
					break;
			}
			const actions = timetable.actions.filter((action) => action.transport == transport.id);
			const people = {
				put: 0,
				get: 0,
				options: 0,
			};
			if (actions) {
				actions.forEach((action) => {
					people[action.action] += parseInt(action.people);
					if (action.action == 'get' && action.option == '1') {
						people.options += parseInt(action.people);
					}
				});
			}
			let timeEditable = false;
			if (!transport.domestic) {
				timeEditable = true;
			} else if (!timetable.transports[index + 1]) {
				// last position of everything
				timeEditable = true;
			} else if (!parseInt(timetable.transports[index + 1].domestic)) {
				// if next stop isnt domestic
				timeEditable = true;
			} else if (timetable.transports[index + 1].vehicle != transport.vehicle) {
				// is it last stop for this transport
				timeEditable = true;
			}
			let stopTimeEditable = true;
			if (!transport.domestic) {
				stopTimeEditable = false;
			} else if (index === 0) {
				// first position of everything
				stopTimeEditable = false;
			} else if (timetable.transports[index - 1].vehicle != transport.vehicle) {
				// prev vehicle is
				stopTimeEditable = false;
			}
			if (timetable.transports[index + 1] && timetable.transports[index + 1].vehicle == transport.vehicle) {
				citiesFromTo.push([transport.city, timetable.transports[index + 1].city]);
			}
			let datetime = [null, null];
			if (transport.datetime) {
				datetime = transport.datetime.split(' ');
			} else if (!transport.domestic) {
				switch (this.side) {
					case 'departure':
						datetime = [this.arrivalDate, null];
						break;
					case 'return':
						datetime = [this.departureFromDestination, null];
						break;
				}
			}
			this.data.push({
				transportId: transport.id,
				vehicleType: vehicleType,
				vehicle: vehicle,
				city: this.findCity(transport.city),
				people: people,
				stopTime: transport.stopTime,
				date: datetime[0],
				time: datetime[1],
				traffic: transport.traffic,
				timeEditable: timeEditable,
				stopTimeEditable: stopTimeEditable,
				domestic: transport.domestic,
			});
		});
		this.data.sort((a, b) => {
			return a.domestic > b.domestic ? -1 : 1;
		});
		this.loadVehicleChange();
		this.api.get('/tourismStopsConnections/?cities=' + citiesFromTo, (result, error) => {
			this.citiesConnections = result.data;
		});
		this.loader = false;
	}

	private loadVehicleChange() {
		this.vehicles = [];
		this.data.forEach((pos) => {
			if (!this.vehicles.includes(pos.vehicle)) {
				this.vehicles.push(pos.vehicle);
			}
		});
	}

	private findCity(cityId: number): string {
		const city = this.cities.find((obj) => obj.id == cityId);
		if (!city) {
			return;
		}
		return city;
	}

	private findVehicle(vehicleId: string) {
		return this.vehiclesAll.find((obj) => obj.id == vehicleId);
	}

	private addDate(date: string, days: number): string {
		const newDate = new Date(date + ' 15:00:00');
		newDate.setDate(newDate.getDate() - days);
		return new Date(newDate.getTime() - newDate.getTimezoneOffset() * 60000)
			.toISOString()
			.replace(/\..+/, '')
			.split('T')[0];
	}
}
